import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/BrandLogo";

const SubscribeCancel = () => {
  return (
    <div className="min-h-screen w-full bg-background flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center">
          <h1>
            <BrandLogo className="mx-auto h-11 w-auto" />
          </h1>
        </div>

        <Card>
          <CardContent className="pt-6 text-center space-y-4">
            <h2 className="text-2xl font-semibold">Payment canceled</h2>
            <p className="text-muted-foreground">No worries -- you can subscribe anytime.</p>
            <Button asChild className="w-full">
              <Link to="/subscribe">Back to pricing</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SubscribeCancel;
